import React from 'react';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, INK, Reveal, Title } from '../components/deck/Type';
const milestones = [{
  label: 'World Bank Group collaboration completed',
  tone: INK.gold
}, {
  label: 'Techstars relationship established',
  tone: INK.violet
}, {
  label: 'Five venture funds signed or engaged',
  tone: INK.blue
}, {
  label: 'Sony Innovation Fund — $100K engagement',
  tone: INK.emerald
}];
const secondary = [{
  v: '20,000+',
  l: 'Startups assessed'
}, {
  v: '2',
  l: 'Provisional patents filed'
}, {
  v: '7',
  l: 'Raiseboards live'
}, {
  v: '36',
  l: 'Companies added to Raiseboards'
}];
export function TractionSlide() {
  return <Slide index={9} data-id="element-299" data-mp="r2ukzc4qxvaf">
      <div className="flex items-start justify-between gap-[3vw]" data-id="element-300" data-mp="r218rvn0qdkw">
        <div className="max-w-[62%]" data-id="element-301" data-mp="1esx95h5jih3r">
          <Eyebrow data-id="element-302" data-mp="1ervkuazijy43">Traction</Eyebrow>
          <Title className="mt-[2.2vh]" data-id="element-303" data-mp="1eqkkkl5a18hq">
            Enterprise adoption is converting the intelligence vision into
            recurring revenue.
          </Title>
        </div>
        <Caption className="max-w-[26%] text-right" data-id="element-304" data-mp="2f6sjnjspp9ow">
          Milestones to date, ordered by sequence rather than modeled revenue.
        </Caption>
      </div>

      <div className="mt-auto grid grid-cols-[38%_1fr] gap-[3.4vw]" data-id="element-305" data-mp="2owc60zfmvloi">
        <div className="flex flex-col justify-end" data-id="element-306" data-mp="2k5ca9xi939nl">
          <p className="text-[clamp(38px,4.8vw,102px)] leading-none text-[#F4F7FC]" style={{
          fontFamily: 'var(--font-serif)'
        }} data-id="element-307" data-mp="2k4kealkqr9ws">
            ~$200K
          </p>
          <p className="mt-[1.4vh] text-[clamp(8px,0.86vw,18px)] uppercase tracking-[0.2em] text-[#7C8699]" data-id="element-308" data-mp="2tudn5eti1axc">
            Annual recurring revenue
          </p>
          <Reveal delay={0.14} className="mt-[3vh] border-t border-white/12 pt-[2vh]" data-id="element-309" data-mp="32w3giq6xyjxr">
            <p className="text-[clamp(18px,2.2vw,46px)] leading-none text-[#2FBE8F]" style={{
            fontFamily: 'var(--font-serif)'
          }} data-id="element-310" data-mp="1dgvwq26btvzy">
              $100K
            </p>
            <p className="mt-[1.1vh] text-[clamp(8px,0.82vw,17px)] uppercase tracking-[0.2em] text-[#7C8699]" data-id="element-311" data-mp="38kbrnsybtzgm">
              Largest single enterprise engagement
            </p>
          </Reveal>
        </div>

        <div className="flex flex-col justify-end" data-id="element-312" data-mp="3hk8ncej4vyl6">
          <div className="relative" data-id="element-313" data-mp="3hjfcp2h20oxr">
            <div className="absolute left-[0.55vh] top-0 h-full w-px bg-white/12" data-id="element-314" data-mp="3mjla6za095nr" />
            <div className="space-y-[2.4vh]" data-id="element-315" data-mp="3rixtxb5kxwm4">
              {milestones.map((m, i) => <Reveal key={m.label} delay={0.1 + i * 0.08} className="relative flex items-center gap-[1.2vw] pl-[2.4vw]" data-id="element-316" data-mp="3rh3j4po0vkvr" data-mpi={i}>
                  <span className="absolute left-0 h-[1.1vh] w-[1.1vh] rounded-full" style={{
                background: m.tone
              }} data-id="element-317" data-mp="55g1idz5soc5" />
                  <span className="text-[clamp(11px,1.22vw,26px)] text-[#DCE3EE]" data-id="element-318" data-mp="e5l0q0u78gf8">
                    {m.label}
                  </span>
                </Reveal>)}
            </div>
          </div>
        </div>
      </div>

      <Reveal delay={0.44} className="mt-[3.4vh] grid grid-cols-4 border-t border-white/12 pt-[2.2vh]" data-id="element-319" data-mp="o7ydp9lfg9ww">
        {secondary.map((s, i) => <div key={s.l} className={i === 0 ? 'pr-[1vw]' : 'border-l border-white/10 pl-[1.2vw] pr-[1vw]'} data-id="element-320" data-mp="j9dmfzo5l0kl" data-mpi={i}>
            <p className="text-[clamp(14px,1.6vw,34px)] leading-none text-[#C3CBD9]" style={{
          fontFamily: 'var(--font-serif)'
        }} data-id="element-321" data-mp="1bx9kp8tdf0jh">
              {s.v}
            </p>
            <p className="mt-[1vh] text-[clamp(7.5px,0.78vw,16px)] uppercase tracking-[0.16em] text-[#7C8699]" data-id="element-322" data-mp="1277uaadjp61e">
              {s.l}
            </p>
          </div>)}
      </Reveal>
    </Slide>;
}